module.exports = __webpack_public_path__ + "img/berg1.2d8e4907.jpg";